"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc998CompositionDialogForm = exports.initialValues = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const types_1 = require("@framework/types");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const inputs_1 = require("../../../../../inputs");
exports.initialValues = {
    contract: {
        parent: {
            contract: "",
        },
        child: {
            contract: "",
        },
    },
    amount: "1",
};
const Erc998CompositionDialogForm = () => {
    const columns = [3];
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: columns, children: [(0, jsx_runtime_1.jsx)(inputs_1.ContractInput, { name: "parentId", related: "parent.contract", data: {
                    contractType: [types_1.TokenType.ERC998],
                    contractStatus: [types_1.ContractStatus.ACTIVE, types_1.ContractStatus.NEW],
                    contractModule: [types_1.ModuleType.HIERARCHY],
                } }), (0, jsx_runtime_1.jsx)(inputs_1.ContractInput, { name: "childId", related: "child.contract", data: {
                    contractType: [types_1.TokenType.ERC20, types_1.TokenType.ERC721, types_1.TokenType.ERC998, types_1.TokenType.ERC1155],
                    contractStatus: [types_1.ContractStatus.ACTIVE, types_1.ContractStatus.NEW],
                    contractModule: [types_1.ModuleType.HIERARCHY],
                } }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.NumberInput, { name: "amount" })] }));
};
exports.Erc998CompositionDialogForm = Erc998CompositionDialogForm;
//# sourceMappingURL=index.js.map